import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=4dbe6040&scoped=true"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"
import style0 from "./copy.vue?vue&type=style&index=0&id=4dbe6040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe6040",
  null
  
)

export default component.exports